import './index.css'

export const Illustration = ({alt="an image", src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.autospuitbedrijfkuperus.nl%2Fwp-content%2Fuploads%2F2017%2F08%2Fplaceholder-300x185.gif&f=1&nofb=1", ...rest}) => (
    <img {...rest} alt={alt} src={src} />
)
